export const CHANGE_SIDEBAR_SHOW = 'changeSidebarShow';
export const COMMIT_CHANGE_SIDEBAR_SHOW = 'changeSidebarShow';
